import { Injectable } from '@angular/core';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { RetryMessage } from 'src/app/tracking/models/retry-message';

@Injectable({
    providedIn: 'root'
})
export class RetryOverviewService {

    constructor(private httpService: JsonHttpService) { }

    getActiveRetries(): Promise<RetryMessage[]> {
        return this.httpService.get('/api/tracking/retries/get-active-retries').toPromise();
    }
}
